/* angular:styles/component:css;88ea7b7acfc6df63b045a370e87bef2bb3232a510dab120d658b01a82897d01f;/codebuild/output/src4169523549/src/friggkantine-admin/src/app/admin-dashboard/membership-v2/dialogs/reset-password-dialog.component.ts */
.v2-reset-hint {
  font-size: 13px;
  color: #666;
  margin: 4px 0 12px;
}
.full {
  width: 100%;
}
/*# sourceMappingURL=reset-password-dialog.component.css.map */
